/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Section_ExploreInputs */



/**
* | output |
* | --- |
* | "Explore" |
*
* @param {Nav_Section_ExploreInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_section_explore = /** @type {((inputs?: Nav_Section_ExploreInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Section_ExploreInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Entdecken")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Explorer")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("探索")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("探索")
	if (locale === "ko") return /** @type {LocalizedString} */ ("둘러보기")
	return /** @type {LocalizedString} */ ("Explore")
});